module.exports = __webpack_public_path__ + "static/media/blueskyBackground.6f0d36c7.png";